import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { designWeights } from "services/constants/designTokens";
import { EmptyState } from "components/CustomComponents/EmptyState";
import { dashboard } from "./dashboardStyles";

// Company Announcements card. Placeholder for now (no announcements backend
// exists yet) — the card is laid out so that wiring a feed later means dropping
// the fetched items in place of the empty state, without reshaping Home.
export const CompanyAnnouncementsSection = () => {
  return (
    <Box sx={dashboard.cardSx}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography fontWeight={designWeights.heading} sx={{ color: dashboard.colors.text }}>
          Company Announcements
        </Typography>
        <Typography sx={{ ...dashboard.linkSx, color: dashboard.colors.blue, opacity: 0.5 }}>
          View All →
        </Typography>
      </Stack>
      <EmptyState subtitle="No announcements right now." size={96} sx={{ py: 2 }} />
    </Box>
  );
};
